"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Login = void 0;
var angular_1 = __importDefault(require("angular"));
var login_controller_1 = __importDefault(require("./login.controller"));
var login_html_1 = __importDefault(require("./login.html"));
function config($stateProvider, $urlRouterProvider) {
    $stateProvider.state("drivecoach.login", {
        url: "/login",
        controller: "LoginController",
        controllerAs: "vm",
        template: login_html_1.default,
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.Login = angular_1.default
    .module("login", [])
    .config(config)
    .controller("LoginController", login_controller_1.default);
